import React from "react";
import "./App.css";
import Home from "./pages/Home";
import {Routes, Route} from 'react-router-dom'
function App() {
 
  return (
    <>
    <Routes>
      <Route path="/" element={<Home/>} />
      {/* <Home/> */}
    </Routes>
    </>
  );
}

export default App;
